import {Component, OnInit,ViewChild,ElementRef,VERSION } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl,FormArray } from '@angular/forms';
import { HttpClient,HttpHeaders,HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable } from "rxjs";
import { map, catchError } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate } from "@angular/common";
import { Location } from '@angular/common';
import { UploadService } from './upload.service';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/loader.service';


@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"],
})
export class RegisterComponent implements OnInit {

	val:any;
	sub:any;
	customers:any;
	isShown: boolean = false ;	
	submitted: boolean = false;
	cmpisShown: boolean = false ;	
	cmpsubmitted: boolean = false;	
	poMessage: boolean;	
	poMessage1: boolean;	
	msg:any;
	cmpmsg:any;
	dst_date_from:any;
	dst_date_to:any;
	headers = new HttpHeaders({ 'Content-Type': 'application/json','API_KEY':'20e20m06i16e14r31p','Version':'1.0' });    	 
	options = { headers: this.headers };	
	username:any;
	password:any;
	token:any;
	opt:any;
	country:any;
	countryshort:any;
	
	public newUser = false;
	// public user: firebase.User;
	public loginForm: FormGroup;

	public errorMessage: any;
	
	
	public registerForm : FormGroup;	
	businessTypes: any;
	countries : any;
	countryProvinces: any;
	
	minDobString:any;
	maxDobString:any;
	statelong:any;
	@ViewChild("business_name") business_name: ElementRef;
	@ViewChild("business_subdomain") business_subdomain: ElementRef;
	@ViewChild("email1") email1: ElementRef;
	
  	
	
	userDetails:any;
	selectedFiles: FileList;

	imgResult: string = '';


	constructor(private http: HttpClient,private route: ActivatedRoute,private router: Router,private formBuilder: FormBuilder,private uploadService: UploadService,private loadingService: LoaderService) {
	
	} 
	
	test(po_value)
	{
		this.uploadService.checkR2(po_value).then(data => { //alert(data);
			
			
				this.http.get(data).subscribe((response) => 
				{ 	
				    this.poMessage1=true;
					this.poMessage=false;
					//console.log(response);
					//alert(response[HttpErrorResponse]['status']);
					//alert(JSON.stringify(response));			
							
				}, (error) => {
					console.log(error.status);
						if(error.status==404)
						{
							this.poMessage=true;
							this.poMessage1=false;
						}
				  //Handle the error here
				  //If not handled, then throw it
				  //throw error; 
			   });
			
			
			
		})
	}

  ngOnInit() 
  {
		//env = environment;
		this.countryshort = environment.defaultCountryId;
		this.country = environment.defaultCountryId;
		
		let dat = new Date().toISOString();
		
		var yearMS = 365 * (1000 * 60 * 60 * 24); // 365 days
		var now = new Date().getTime();		
		var minDobMS = now - (122.5 * yearMS);		
		this.minDobString = new Date(minDobMS).toISOString().slice(0, 10);
		var eighteenYearsAgo = new Date();
		var eighteenYearsAgo1 = eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear()-18);
		this.maxDobString =new Date(eighteenYearsAgo1).toISOString().slice(0, 10);
		
  
		//this.username='Admin';
		//this.password='123456';
	  
	  
		this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
		{
			this.token=response;
			//alert(this.token.access_token);
			let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
			let o = { headers: h };					
					
			
			
			this.http.get(environment.api_url+'/v1/country',o).subscribe((response) => 
			{ 	
				this.countries=response;			
						
			});
			
			//alert(environment.defaultCountryId);
			
			this.http.get(environment.api_url+'/v1/countryProvince/Country/'+environment.defaultCountryId,o).subscribe((response) => 
			{ 
				//alert(JSON.stringify(response));
				this.countryProvinces=response;			
						
			});
					
			
						
		});	
		
		
		this.registerForm = this.formBuilder.group({            
			business_type: ['', Validators.required],
			business_vertical_name: ['', Validators.required],
			business_vertical_description: ['', Validators.required],			
			business_name: ['', Validators.required],		
			business_subdomain: ['', Validators.required],		
			legal_name: ['', Validators.required],							
			addressline1: [''],
			addressline2: [''],			
			street_no: [''],
			street_name: [''],			
			area_name: ['', Validators.required],			
			region_name: [''],			
			zip: ['', Validators.required],		
			stateshort: ['', Validators.required],				
			admin_first_name: ['', Validators.required],
			admin_last_name: [''],
			admin_gender: ['', Validators.required],
			admin_dob: ['', Validators.required],
			admin_title: ['', Validators.required],
			admin_phone: ['', Validators.required],				
			admin_email: ['', Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")],
			//email: ['', [Validators.required, Validators.email]],
            //password: ['', [Validators.required, Validators.minLength(6)]]
        });
  
  
  }
  
  

	getBusinessName(tr)
	{
		this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
		{
			this.token=response;
			//alert(this.token.access_token);
			let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
			let o = { headers: h };
		
			this.http.get(environment.api_url+'/v1/companyPO/BusinessName/'+tr.target.value,o).subscribe((response) => 
			{ 		
				//alert(response);
				if(Object.keys(response).length!=0)
				{
					alert("Business Name Already Exist");
					this.registerForm.controls['business_name'].setValue("");		
					this.business_name.nativeElement.focus();

				}
						
			});
		});				
	  
	}
	
	
	
	getBusinessSubdomain(tr)
	{
		
		this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
		{
			this.token=response;
			//alert(this.token.access_token);
			let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
			let o = { headers: h };
		
			this.http.get(environment.api_url+'/v1/companyPO/BusinessSubdomain/'+tr.target.value.toLowerCase(),o).subscribe((response) => 
			{ 		
				///alert(JSON.stringify(response));
				if(Object.keys(response).length!=0)
				{
					alert("Business Subdomain Already Exist");
					this.registerForm.controls['business_subdomain'].setValue("");		
					this.business_name.nativeElement.focus();

				}
						
			});
		});					
	  
	}
	
	
	getEmail(tr)
	{
		
		this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
		{
			this.token=response;
			//alert(this.token.access_token);
			let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
			let o = { headers: h };
		
			this.http.get(environment.api_url+'/v1/companyPO/Poc/'+tr.target.value,o).subscribe((response) => 
			{ 		
				//alert(response);
				if(Object.keys(response).length!=0)
				{
					alert("Email Already Exist");
					this.registerForm.controls['admin_email'].setValue("");		
					this.email1.nativeElement.focus();

				}
						
			});
		});					
	  
	}
	
	getState(tr)
	{		
	  this.statelong=tr.target.options[tr.target.options.selectedIndex].text;	  	 
	 
	}
  
  onUser()
  {
	  this.loginForm.controls['password'].setValue('123456');	
  }
  
  onSubmit()
	{
		
		this.submitted = true;
		if (this.registerForm.invalid) 
		{
			return;
		}
        						
		this.registerForm.value.country=this.country;				
		this.registerForm.value.countryshort=this.country;				
		this.registerForm.value.statelong=this.statelong;			        
		this.registerForm.value.billing_name=this.registerForm.value.business_name;			        
		this.registerForm.value.billing_country=this.country;				
		this.registerForm.value.billing_countryshort=this.country;	
		this.registerForm.value.start_date=new Date().toISOString();			
		var v= this.registerForm.value.business_subdomain.replace(/[^a-zA-Z ]/g,'');
		this.registerForm.value.business_subdomain=v.replace(/ /g,'').toLowerCase();
		
		this.loadingService.setLoading(true);
		
		this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.opt).subscribe((response) => 
		{
			this.token=response;
			let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
			let o = { headers: h };
			
			this.http.post(environment.api_url+'/v1/companyPO', this.registerForm.value,o).subscribe((response) => 
			{
				//alert(JSON.stringify(response));
				this.loadingService.setLoading(false);
				this.router.navigate(['/auth/Thankyou']);								
			});			
						
		});
	}
  

}
